import Config from 'netxcore@netx/core-app/config';

Object.assign(Config, {
	CSS_CUSTOM_PROPERTY_PREFIX: '--mdc-theme-',
});

export default Config;
